export enum ButtonType {
    primary = 'primary',
    secondary = 'secondary',
    borderOff = 'border-off',
    borderOffPrimary = 'border-off-primary',
}
